export const cardStyle = {
  backgroundColor: "#ffffff",
  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  padding: "24px"
};

export const breadcrumbsWrapper = {
  marginBottom: "20px"
};

export const getAlertsLinkStyle = (isHovered) => ({
  color: "#000000",
  textDecoration: isHovered ? "underline" : "none"
});

export const getAlertReferenceLinkStyle = (isHovered) => ({
  color: "#000000",
  fontWeight: 700,
  textDecoration: isHovered ? "underline" : "none"
});

export const getStoreLinkStyle = (isHovered) => ({
  textDecoration: "underline",
  color: isHovered ? "#FF6B35" : "#000000",
  cursor: "pointer",
  transition: "color 0.2s ease"
});

export const getSensorLinkStyle = (isHovered) => ({
  textDecoration: "underline",
  color: isHovered ? "#FF6B35" : "#000000",
  cursor: "pointer",
  transition: "color 0.2s ease"
});

export const tagListContainer = {
  // Uses fable:pb-4 className
};

export const spacerDiv = {
  marginTop: "8px" // fable:pt-2
};
